import _get from 'lodash/get';
import _pick from 'lodash/pick';
import { User, UserRoleEnum } from 'graphql-common';
import { getAllOption, PredefinedValues } from '@lib/enums/form';
import { TFunction } from 'i18next';
import { SelectOption } from '@lib/components/Select/types';
import { Values } from '@lib/interfaces/form';
import UserFieldNames from '@lib/enums/fieldNames/userFieldNames';
import { getRoleOption } from '@lib/utils/roles';
import getPhoneNumberValueFromQueryData from '@lib/utils/getPhoneNumberValueFromQueryData';
import getEmptyDefaultValues from 'routes/Users/utils/getEmptyDefaultValues';
import { UserAssignationType } from 'components/UserForm/utils/enums';

export default function getDefaultValuesFromQueryData(
  t: TFunction<'translation', undefined>,
  data?: User,
): Values {
  if (data?.id === undefined) return getEmptyDefaultValues();
  const roleValue = _get(data, 'role');

  const siteMemberships = _get(data, 'sites.collection', []) as unknown as {
    id: string;
    name: string;
  }[];
  let siteMembershipsArray = siteMemberships.map(({ id, name }) => ({
    label: name,
    value: id,
  }));
  if (
    siteMembershipsArray.length === 0 &&
    roleValue === UserRoleEnum.FullAdmin
  ) {
    siteMembershipsArray = [getAllOption(t)];
  }

  const sectorsMemberships = _get(
    data,
    'sectors.collection',
    [],
  ) as unknown as {
    id: string;
    name: string;
  }[];
  let sectorsMembershipsArray = sectorsMemberships.map(({ id, name }) => ({
    label: name,
    value: id,
  }));
  if (
    sectorsMembershipsArray.length === 0 &&
    roleValue === UserRoleEnum.FullAdmin
  ) {
    sectorsMembershipsArray = [getAllOption(t)];
  }

  let assignationType = { value: UserAssignationType.Sector };
  if (
    siteMembershipsArray.length &&
    siteMembershipsArray[0].value !== PredefinedValues.all
  ) {
    assignationType = { value: UserAssignationType.Site };
  }

  return {
    ...getEmptyDefaultValues(),
    ..._pick(data, [
      'id',
      UserFieldNames.Email,
      UserFieldNames.FirstName,
      UserFieldNames.LastName,
      UserFieldNames.PersonalId,
      'deactivatedAt',
    ]),
    [UserFieldNames.Username]: _get(data, 'username'),
    [`${UserFieldNames.Email}-copy`]: _get(data, 'email'),
    [UserFieldNames.Role]: getRoleOption(_get(data, 'role')),
    [UserFieldNames.PhoneNumber]: getPhoneNumberValueFromQueryData(data),
    [UserFieldNames.AssignationType]: assignationType,
    [UserFieldNames.SectorMemberships]: sectorsMembershipsArray,
    [UserFieldNames.SiteMemberships]: siteMembershipsArray,
    [UserFieldNames.Team]: {
      value: _get(data, 'team.id'),
      label: _get(data, 'team.name'),
      color: _get(data, 'team.color'),
    } as SelectOption,
  };
}
